import UploadIcon from '@mui/icons-material/Upload'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'

import styled, { css } from 'styled-components'

import { TypographyComponent } from '../../components/Typography'
import { Button } from 'src/components/Button'

export const ContainerFlex = styled('form')(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;
    width: 100%;
    justify-content: center;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 100%;
  `
)

export const Title = styled('h1')(
  ({ theme }) => css`
    font-size: ${theme.typograph.fontsize.h8};
  `
)

export const Typography = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h4};
      font-weight: 300;
      text-transform: uppercase;

      span {
        font-weight: 700;
      }
    }
  `
)

export const DescriptionModal = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h4};
      font-weight: 300;
      text-align: start;
    }
  `
)

export const List = styled('ul')(
  ({ theme }) => css`
    padding-left: ${theme.layout.padding.medium};
  `
)

export const ItemList = styled('li')(
  ({ theme }) => css`
    font-size: ${theme.typograph.fontsize.h5};
  `
)

export const DownloadButton = styled(Button)(
  ({ theme }) => css`
    && {
      display: flex;
      padding: 0;
      align-items: center;
      justify-content: start;
      gap: ${theme.layout.gap.medium};
      border: solid 1px ${theme.colors.primary.main70} !important;

      @media (max-width: ${theme.screen.small}) {
        width: 100%;
      }

      span {
        font-size: ${theme.typograph.fontsize.h4};
        text-transform: uppercase;

        @media (max-width: ${theme.screen.small}) {
          width: 100%;
        }
      }
    }
  `
)

export const RenderDetail = styled('div')(
  ({ theme }) => css`
    display: flex;

    @media (max-width: ${theme.screen.small}) {
      width: 100%;
    }
  `
)

export const ButtonIcon = styled('div')(
  ({ theme }) => css`
    display: flex;
    background: ${theme.colors.primary.main70};
    padding: ${theme.layout.padding.medium};

    svg {
      color: ${theme.colors.base.white};
    }
  `
)

export const Link = styled('div')(
  ({ theme }) => css`
    display: flex;

    span {
      font-size: ${theme.typograph.fontsize.h4};
      text-transform: uppercase;
      margin-right: ${theme.layout.margin.medium};
    }
  `
)

export const ModalBox = styled('div')(
  ({ theme }) => css`
    padding: ${theme.layout.padding.medium};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  `
)

export const ModalBoxButtons = styled('div')(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: ${theme.layout.gap.medium};
    margin-top: ${theme.layout.margin.base * 6}rem;
  `
)

export const ContainerUpload = styled('div')(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `
)

export const ContainerUploadInput = styled('div')(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  `
)

export const ContainerInfo = styled('div')(
  ({ theme }) => css`
    && {
      display: flex;
      align-items: center;
      gap: ${theme.layout.gap.small};
    }
  `
)

export const TextInfo = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      width: 100%;
      font-size: ${theme.typograph.fontsize.h4};
      color: ${theme.colors.error.main};
      font-weight: 300;
    }
  `
)

export const ButtonInfo = styled(Button)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.error.main};
      text-decoration: underline;
      font-weight: 700;

      &:hover {
        background-color: rgb(210 25 25 / 4%);
      }
    }
  `
)

export const PriorityHigh = styled(PriorityHighIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      color: ${theme.colors.error.main};
    }
  `
)

export const UploadIconStyled = styled(UploadIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
    }
  `
)
